import React, { Component, PropTypes } from 'react';
import { Link, browserHistory } from 'react-router';
import { LoadingIndicator } from 'common/components/preloader';
import { Meta } from 'common/components/meta';

/* get banner title and content referring to provided discount code */
export const getBannerContents = (code, scenario) => {
  const contents = { title: '', content: '' };

  if (!code) {
    return null;
  }

  contents.icon = <i className="fa fa-tag"/>;

  /* build discount code description based on its characteristics */
  contents.content = 'Your '
  if (code.kind === 'flat') {
    contents.content += `$${code.amount} `;
  } else {
    contents.content += `${code.percentage}% `;
  }
  contents.content += 'discount ';
  code.free_features.forEach(f => {
    contents.content += `and ${f} `;
  })
  contents.content += 'will be applied when you post your project.'

  /* code has just been fetched */
  if (scenario === 'fetched') {
    contents.title = "It's in the bag!";

  /* code is ready to be applied at PAP */
  } else {
    contents.title = "Your discount code is ready to be applied!";
  }

  return contents;
}


/**
 * Discount code screen.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class DiscountCode extends Component {
  constructor(props) {
    super(props);

    this.state = { fetched: null, error: '' };
  }

  componentDidMount() {
    const { codeSlug, fetch, showBanner, router } = this.props;

    let osi_affiliate_id = null;
    let osi_prodgroup = null;

    if (router.location && router.location.query) {
      osi_affiliate_id = router.location.query.affiliate_id;
      osi_prodgroup = router.location.query.prodgroup;
    }

    fetch(codeSlug, osi_affiliate_id, osi_prodgroup).then(({ data }) => {

      this.setState({ fetched: true });

      const bannerContents = getBannerContents(data, 'fetched');
      showBanner(bannerContents.title, bannerContents.content, bannerContents.icon);

      /* redirect user if an internal redirect URL is provided */
      if (data.redirect_url) {
        browserHistory.push(data.redirect_url);
      }

    }).catch(err => {
      let error = 'The coupon code you are trying to retrieve is not valid anymore.';
      if (err.status == 404) {
        error = 'The coupon code you are trying to retrieve does not exist.';
      }
      this.setState({ fetched: false, error });
    })
  }

  render() {
    const { fetched, error } = this.state;

    return (
      <div className="l-content info-screen" id="content">
        <Meta title="Coupon Code" />
        <header className="l-header">
          <div className="header-middle">
            <h2 className="middle-left-title">
              {fetched === null?
              'Retrieving coupon code...':
              (fetched? 'Success!': 'Whoops!')}
            </h2>
          </div>
        </header>

        {fetched === null?
        <LoadingIndicator/>:
        <div className="row">
          <div className="columns medium-8 small-16">

            <h2>{fetched? "It's in the bag!" : 'Invalid coupon code'}</h2>

            {fetched?
            <p>
              You coupon code will be applied when you post your project.
            </p>:
            <p>
              { error } Please get in touch via our <Link to='/help/'>help center</Link>.
            </p>}

            {!fetched && <Link className="btn btn-primary" to='/help/'>Get in Touch</Link>}

          </div>

          <div className="columns medium-8 small-16 icon hide-for-small-only">
            <i className={"fa fa-" + (fetched? "check-circle" : "frown-o")}></i>
          </div>
        </div>}

      </div>
    );
  }
}

DiscountCode.propTypes = {
  fetch: PropTypes.func,
  showBanner: PropTypes.func,
  codeSlug: PropTypes.string,
};



// WEBPACK FOOTER //
// ./common/components/discount_code.jsx